import { css } from "@emotion/react";
import { EXONN_HUB_ORDER_PREVIEW_MODAL_Z_INDEX } from "src/admin/modules/b2b-gate-order/components/ExonnHub/ExonnHub.constants.ts";

export const cartFloating = css({
  zIndex: EXONN_HUB_ORDER_PREVIEW_MODAL_Z_INDEX,
  display: "flex",
  flexDirection: "column",
});

export const container = css({
  position: "relative",
});
